import { MetaService } from 'app/services/meta.service';
import { LoaderService } from './../../services/loader.service';
import { ThemeIconService } from 'app/services/theme-icon.service';
import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  Renderer2,
  HostListener,
  afterEveryRender,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
// import { isScullyRunning } from '@scullyio/ng-lib';
declare let APIMaticDevPortal: any;

const EMPTY_KEY = '';

@Component({
  selector: 'app-api-embed',
  templateUrl: './api-specification-embed.component.html',
  styleUrls: ['./api-specification-embed.component.scss'],
  standalone: false,
})
export class ApiSpecificationEmbedComponent implements AfterViewInit, OnChanges, OnDestroy {
  tryItButtons;
  authLabelText = 'If you want to generate a key and try out the API, please create a free account and login.';
  previousRouteSusbription = 0;
  hasContent = true;
  getapikeyInfoModal = false;
  sub: any;
  apiMaticScriptElement: HTMLScriptElement;
  portalScriptElement: HTMLScriptElement;
  walkthroughScriptElement: HTMLScriptElement;
  apiMaticElement: HTMLElement;
  headerHeight;
  footerHeight;
  private currentSpecKey = '';
  private _apiKey = EMPTY_KEY;

  private trackedListeners: {
    target: EventTarget;
    type: string;
    listener: EventListenerOrEventListenerObject;
    options?: boolean | AddEventListenerOptions;
  }[] = [];
  private originalAddEventListener: typeof window.addEventListener | null = null;
  private originalRemoveEventListener: typeof window.removeEventListener | null = null;
  @Input()
  set apiKey(value: string) {
    this._apiKey = value;
    (window as any).apiConfigKey = value;
    if (value) {
      this._apiKeyFetched = true;
      this.loadConfigScriptIfReady();
    }
  }
  get apiKey(): string {
    return this._apiKey;
  }
  @Input() family;
  @Input() api;
  @Input() apiItem;
  @Input() version;
  @ViewChild('parent') parent: ElementRef;
  private _configScriptLoaded = false;
  private _apiKeyFetched = false;
  private _portalScriptLoaded = false;
  constructor(
    public loaderService: LoaderService,
    public metaService: MetaService,
    private themeIconService: ThemeIconService,
    private _renderer: Renderer2
  ) {
    const ref = afterEveryRender(() => {
      if (window.innerWidth <= 990) {
        this.getHeight('header');
        if (this.headerHeight) {
          this.setHeight('header');
          ref.destroy();
        }
      } else {
        this.getHeight('headerfooter');
        if (this.headerHeight && this.footerHeight) {
          this.setHeight('headerfooter');
          ref.destroy();
        }
      }
    });
  }

  private setPortal(apiItem) {
    const currentTimeStamp = Date.now();
    const currentTheme = this.themeIconService.getDefaultSetting();
    this.apiMaticElement = this.parent.nativeElement.querySelector('#apimatic-widget');
    this.loadPortalScripts(apiItem, currentTimeStamp, currentTheme);
  }

  private installEventListenerInterceptors(): void {
    if (!this.originalAddEventListener) {
      this.originalAddEventListener = window.addEventListener;
    }
    if (!this.originalRemoveEventListener) {
      this.originalRemoveEventListener = window.removeEventListener;
    }

    const trackedListeners = this.trackedListeners;
    const originalWindowAdd = this.originalAddEventListener!;
    const originalDocAdd = document.addEventListener;

    window.addEventListener = function (
      type: string,
      listener: EventListenerOrEventListenerObject,
      options?: boolean | AddEventListenerOptions
    ) {
      trackedListeners.push({ target: window, type, listener, options });
      return originalWindowAdd.call(window, type, listener, options);
    } as typeof window.addEventListener;

    document.addEventListener = function (
      type: string,
      listener: EventListenerOrEventListenerObject,
      options?: boolean | AddEventListenerOptions
    ) {
      trackedListeners.push({ target: document, type, listener, options });
      return originalDocAdd.call(document, type, listener, options);
    } as typeof document.addEventListener;
  }

  private restoreEventListenerFunctions(): void {
    if (this.originalAddEventListener) {
      window.addEventListener = this.originalAddEventListener;
    }
    if (this.originalRemoveEventListener) {
      window.removeEventListener = this.originalRemoveEventListener;
    }
    document.addEventListener = EventTarget.prototype.addEventListener as typeof document.addEventListener;
  }

  private removeTrackedListeners(): void {
    for (const entry of this.trackedListeners) {
      try {
        entry.target.removeEventListener(entry.type, entry.listener, entry.options);
      } catch (e) {}
    }
    this.trackedListeners.length = 0;
  }

  private loadPortalScripts(apiItem, currentTimeStamp: number, currentTheme: string) {
    this.installEventListenerInterceptors();

    this.apiMaticScriptElement = this._renderer.createElement('script');
    this.apiMaticScriptElement.src = `assets/matic/portal-script/js/portal.v7-uber.js?ngsw-bypass=${currentTimeStamp}`;
    this.apiMaticScriptElement.defer = true;

    this.apiMaticScriptElement.onload = () => {
      const currentTimeStamp = Date.now();
      this.portalScriptElement = this._renderer.createElement('script');
      this.portalScriptElement.src = this.family
        ? `assets/matic/${this.family}/${this.api}/${this.version}/static/js/portal.js?ngsw-bypass=${currentTimeStamp}`
        : `assets/matic/${this.api}/${this.version}/static/js/portal.js?ngsw-bypass=${currentTimeStamp}`;
      this._renderer.appendChild(this.parent.nativeElement, this.portalScriptElement);

      this.portalScriptElement.onload = () => {
        this.restoreEventListenerFunctions();
        if (APIMaticDevPortal && APIMaticDevPortal.setThemeMode) {
          APIMaticDevPortal.setThemeMode(currentTheme);
        }
        this._portalScriptLoaded = true;
        this.loadConfigScriptIfReady();
        if (apiItem['walkthrough']) {
          const currentTimeStamp = Date.now();
          this.walkthroughScriptElement = this._renderer.createElement('script');
          this.walkthroughScriptElement.src = this.family
            ? `assets/matic/${this.family}/${this.api}/${this.version}/static/walkthroughs/walkthrough.js?ngsw-bypass=${currentTimeStamp}`
            : `assets/matic/${this.api}/${this.version}/static/walkthroughs/walkthrough.js?ngsw-bypass=${currentTimeStamp}`;
          this.walkthroughScriptElement.defer = true;
          this._renderer.appendChild(this.parent.nativeElement, this.walkthroughScriptElement);
        }
        this.loaderService.hideInitialLoader();
      };
      this.loaderService.hideInitialLoader();
    };
    this._renderer.appendChild(this.parent.nativeElement, this.apiMaticScriptElement);
  }

  private loadConfigScript(): void {
    if (this._configScriptLoaded) {
      return;
    }
    (window as any).apiConfigKey = this.apiKey;

    const currentTimeStamp = Date.now();
    const configScriptElement = this._renderer.createElement('script');
    configScriptElement.src = this.family
      ? `assets/matic/${this.family}/${this.api}/${this.version}/static/js/config.js?ngsw-bypass=${currentTimeStamp}`
      : `assets/matic/${this.api}/${this.version}/static/js/config.js?ngsw-bypass=${currentTimeStamp}`;

    this._renderer.appendChild(this.parent.nativeElement, configScriptElement);
    this._configScriptLoaded = true;
  }

  private loadConfigScriptIfReady(): void {
    if (this._apiKeyFetched && this._portalScriptLoaded && !this._configScriptLoaded) {
      this.loadConfigScript();
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth > 990) {
      this.getHeight('headerfooter');
      this.setHeight('headerfooter');
    } else {
      this.getHeight('header');
      this.setHeight('header');
    }
  }

  private getHeight(heightFor: string) {
    if (heightFor === 'header') {
      const headerElement = document.querySelector('app-global-header');
      if (headerElement && headerElement.clientHeight) {
        this.headerHeight = headerElement.clientHeight;
      }
    } else {
      const headerElement = document.querySelector('app-global-header');
      if (headerElement && headerElement.clientHeight) {
        this.headerHeight = headerElement.clientHeight;
      }
      const footerElement = document.querySelector('.footer');
      if (footerElement && footerElement.clientHeight) {
        this.footerHeight = footerElement.clientHeight;
      }
    }
  }

  private setHeight(heightFor: string) {
    const apimaticElement = document.querySelector('.-apimatic-container');
    if (heightFor === 'header') {
      const headerFooterElementHeight = this.headerHeight;
      apimaticElement.setAttribute('style', `height: calc(99.8vh - ${headerFooterElementHeight}px)`);
    } else {
      const headerFooterElementHeight = this.headerHeight + this.footerHeight;
      apimaticElement.setAttribute('style', `height: calc(99.8vh - ${headerFooterElementHeight}px)`);
    }
  }

  ngAfterViewInit(): void {
    this.currentSpecKey = `${this.family}-${this.api}-${this.version}`;
    this.setPortal(this.apiItem);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['api'] || changes['family'] || changes['version'] || changes['apiItem']) &&
      !(
        changes['api']?.firstChange ||
        changes['family']?.firstChange ||
        changes['version']?.firstChange ||
        changes['apiItem']?.firstChange
      )
    ) {
      const newSpecKey = `${this.family}-${this.api}-${this.version}`;
      const specChanged = newSpecKey !== this.currentSpecKey;
      const apiItemChanged = !!changes['apiItem'];

      if (specChanged || apiItemChanged) {
        if (specChanged) {
          this.currentSpecKey = newSpecKey;
        }

        this.cleanupPortal();

        this._configScriptLoaded = false;
        this._portalScriptLoaded = false;

        this._apiKeyFetched = !!this._apiKey;

        this.setPortal(this.apiItem);
      }
    }
  }

  private cleanupPortal(): void {
    this.removeTrackedListeners();
    this.restoreEventListenerFunctions();

    try {
      if ((window as any).APIMaticDevPortal) {
        delete (window as any).APIMaticDevPortal;
      }
    } catch (e) {}

    if (this.apiMaticScriptElement) {
      try {
        this.apiMaticScriptElement.remove();
      } catch (e) {}
    }
    if (this.portalScriptElement) {
      try {
        this.portalScriptElement.remove();
      } catch (e) {}
    }
    if (this.walkthroughScriptElement) {
      try {
        this.walkthroughScriptElement.remove();
      } catch (e) {}
    }

    if (this.apiMaticElement) {
      this.apiMaticElement.innerHTML = '';
    }

    if ('apiConfigKey' in (window as any)) {
      delete (window as any).apiConfigKey;
    }
  }

  ngOnDestroy(): void {
    this.cleanupPortal();
  }
}
